import * as React from "react";
import styled, { css } from "styled-components";

import { useOnScreen } from "src/library/hooks/useOnScreen";
import { Text } from "src/library/components/Text";

interface InfinitLoadMoreProps {
  onLoad: () => void;
  disabled: boolean;
}

/**
 * Renders a load more button that when inview and not disabled with run the load function
 */
export const InfinitLoadMore: React.FC<InfinitLoadMoreProps> = ({ onLoad, disabled }) => {
  const LoadMoreRef = React.useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(LoadMoreRef);

  React.useEffect(() => {
    if (isOnScreen && !disabled) {
      onLoad();
    }
  }, [
    disabled,
    isOnScreen,
    onLoad
  ]);

  return (
    <LoadMoreWrapper
      style={{ display: disabled ? "none" : "block" }}
      ref={LoadMoreRef}
      className="load-more"
      onClick={() => !disabled ? onLoad() : null}
    >
      <Text>
        Load more
      </Text>
    </LoadMoreWrapper>
  );
};

const LoadMoreWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    justify-content: center;

    span {
      padding: ${theme.spacing.padding.md};
      display: block;
      text-align: center;
      color: ${theme.colors.primaryDark};

      &:hover {
        cursor: pointer;
      }
    }
  `}
`;
